// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__mJ-Ps","number":"Pagination_number__b4PEk","active":"Pagination_active__RKgHe","arrow":"Pagination_arrow__jpjxE"};